module.exports = __webpack_public_path__ + "img/noPortrait@2x copy.db9e7f0d.png";